module.exports = __webpack_public_path__ + "img/coke-zero_3.f6ab163c.jpg";